// noinspection JSIgnoredPromiseFromCall

import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { postGlobalAlertSettingsByFleetId } from '../../services/DeviceService';
import { AlertsConfigurationRequest, AlertsConfiguration } from '../../types/Devices';

type Result = UseMutationResult<AlertsConfiguration, Error, AlertsConfigurationRequest>;

function usePostGlobalAlertSettingsByFleetId(successCb: () => void, failureCb: (error: string) => void): Result {
  const queryClient = useQueryClient();

  return useMutation(postGlobalAlertSettingsByFleetId, {
    onSuccess: () => {
      successCb();
      queryClient.invalidateQueries({ queryKey: ['device-global-alerts-settings'] });
    },
    onError: (error: Error) => {
      failureCb(error.message);
    },
  });
}

export default usePostGlobalAlertSettingsByFleetId;
